"use client";

import { useMemo } from "react";
import { PASSWORD_REQUIREMENTS } from "@/constants";

/**
 * usePasswordValidation Custom Hook
 *
 * Provides password validation logic and requirements checking.
 * Can be used across different components that need password validation.
 */
export const usePasswordValidation = (password: string) => {
  // Check each password requirement
  const passwordChecks = useMemo(() => {
    const result: Record<string, boolean> = {};
    Object.entries(PASSWORD_REQUIREMENTS).forEach(([key, req]) => {
      result[key] = req.test(password || "");
    });
    return result;
  }, [password]);

  // Check if password meets all requirements
  const isPasswordValid = useMemo(() => {
    return Object.values(passwordChecks).every(Boolean);
  }, [passwordChecks]);

  // Get password requirements for display
  const passwordRequirements = PASSWORD_REQUIREMENTS;

  return {
    passwordChecks,
    isPasswordValid,
    passwordRequirements,
  };
};
